import { render } from "./MainTopLine.vue?vue&type=template&id=3faac043&scoped=true&ts=true"
import script from "./MainTopLine.vue?vue&type=script&lang=ts"
export * from "./MainTopLine.vue?vue&type=script&lang=ts"

import "./MainTopLine.vue?vue&type=style&index=0&id=3faac043&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3faac043"]])

export default __exports__